(function() {
    'use strict';

    angular
        .module('elogbooks')
        .config(Translations);
    function Translations($translateProvider) {
        $translateProvider.translations('en-gb', {
            PERMISSIONS_OVERVIEW: 'Permissions Overview',
            PERMISSION_APPLIED_DIRECTLY: 'Applied Directly',
            PERMISSION_VIA_ROLE: 'Applied By Role',
            INHERITED_VIA_PERMISSION: 'Inherited From Permission',
            INVALID_PERMISSION_CODE_PREFIX: 'Invalid permission code prefix',
            UNKNOWN_PERMISSION_CODE: 'Unknown permission code',

            SITE_PERMISSION_OVERVIEW: 'Site Permission',
            USER_PERMISSION: 'User Permission',
            REPORT_PERMISSION: 'Report Permission',
            OPERATIVE_PERMISSION: 'Operative Permission',

            EXPORT_PERMISSIONS_OVERVIEW_USERS: 'Export Permissions User List'
        });
    }
})();
